import { createSlice } from '@reduxjs/toolkit';

const projectSlice = createSlice({
	name: 'project',
	initialState: {
		projectShare: false,
		projectDelete: false,
	},
	reducers: {
		setActionsProject(state, action) {
			const currState = state;
			const {key, value} = action.payload;

			if (key) {
				currState[key] = value;
			}
		},
	},
});

export const contentActions = projectSlice.actions;
export default projectSlice;
